import LazyLoad from "vanilla-lazyload";
import { initializeMap } from "Functions/map";

import "Layouts/default";

import "Components/form/contact";

const branches = window.branchesData;

window.mapLazyLoad = new LazyLoad({
    threshold: 125,
    elements_selector: ".js-map-branches",
    callback_enter: (el) => {
        initializeMap(".js-map-branches", branches, { panOffsetY: -40 });
    },
});
